import { render, staticRenderFns } from "./yuanzhuanshu.vue?vue&type=template&id=72a7b4b4&"
import script from "./yuanzhuanshu.vue?vue&type=script&lang=js&"
export * from "./yuanzhuanshu.vue?vue&type=script&lang=js&"
import style0 from "./yuanzhuanshu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports